import O_CapsuleCreateHeader from './O_CapsuleCreateHeader';
import O_CapsuleCreateHeaderMobile from './O_CapsuleCreateHeaderMobile';
import { useIsMobile } from '@/hooks/useIsMobile';

interface O_CapsuleCreateHeaderResponsiveProps {
  onSaveContent?: (contentItem: any) => void;
  onPreviewClick?: () => void;
  onPublishClick?: () => void;
  onOpenAddContent?: () => void;
  onOpenBurgerMenu?: () => void;
  showPreviewButton?: boolean;
  isScenarioPreview?: boolean;
  showUploadButton?: boolean;
}

export default function O_CapsuleCreateHeaderResponsive({
  onSaveContent,
  onPreviewClick,
  onPublishClick,
  onOpenAddContent,
  onOpenBurgerMenu,
  showPreviewButton = false,
  isScenarioPreview = false,
  showUploadButton = false,
}: O_CapsuleCreateHeaderResponsiveProps) {
  const isMobile = useIsMobile(878);

  if (isMobile) {
    return (
      <O_CapsuleCreateHeaderMobile
        onOpenAddContent={onOpenAddContent}
        onOpenBurgerMenu={onOpenBurgerMenu}
        onPreviewClick={onPreviewClick}
        onPublishClick={onPublishClick}
        showPreviewButton={showPreviewButton}
        isScenarioPreview={isScenarioPreview}
        showUploadButton={showUploadButton}
      />
    );
  }

  return (
    <O_CapsuleCreateHeader
      onSaveContent={onSaveContent}
      onPreviewClick={onPreviewClick}
      onPublishClick={onPublishClick}
      onOpenAddContent={onOpenAddContent}
      showPreviewButton={showPreviewButton}
      isScenarioPreview={isScenarioPreview}
      showUploadButton={showUploadButton}
    />
  );
}
